<template>
	<div class="page-dashboard relative">
		<div class="container-fluid" v-if="(!isCollaborator && isHaveTransactions) || (isSuperAdmin && isHaveTransactions) || isFinance">
			<h2 class="text-primary mb-4">{{ $t('Billing') }}</h2>
			<div v-if="!user.roles.includes('finance') && user.userSubscriptions.length > 0">
				<button
					class="btn btn-submit btn-default text-white mr-4"
					@click="viewNextInvoiceSelf(user.id)">
					{{ $t('Upcoming Invoice') }}
				</button>
			</div>
			<div class="mb-5">
				<div v-if="isFinance">
					<div class="cards-statistics">
						<div class="card-statistics">
							<div class="p-5 text-center absolute" v-if="isFetchingStatistics">
								<div class="is-loading large"></div>
							</div>
							<h3 class="mt-3 mb-2">{{$t('Balance')}}</h3>
							<div class="text-statistics" v-if="!isFetchingStatistics">
								<div class="text-superlg text-primary">{{amountPaid(statistics && statistics.balance && statistics.balance ? statistics.balance : '0')}}</div>
								<div>{{$t('Current balance ')}}</div>
							</div>
						</div>
						<div class="card-statistics pointer" @click="openModalList('paid')">
							<div class="mt-3 p-5 text-center absolute" v-if="isFetchingStatistics">
								<div class="is-loading large"></div>
							</div>
							<h3 class="mb-2">{{$t('Paid')}}</h3>
							<div class="text-statistics" v-if="!isFetchingStatistics">
								<div class="text-superlg text-primary">{{amountPaid(statistics && statistics.paid && statistics.paid.amount ? statistics.paid.amount : '0')}}</div>
								<div v-if="statistics && statistics.paid && statistics.paid.total !== 0">{{$t('from ')}}<span class="text-primary">{{statistics && statistics.paid && statistics.paid.total ? statistics.paid.total : '0'}}</span> transactions</div>
								<div v-else>{{$t('There is no transaction')}}</div>
							</div>
						</div>
						<div class="card-statistics pointer" @click="openModalList('pending')">
							<div class="mt-3 p-5 text-center absolute" v-if="isFetchingStatistics">
								<div class="is-loading large"></div>
							</div>
							<h3 class="mb-2">{{$t('Unpaid')}}</h3>
							<div class="text-statistics" v-if="!isFetchingStatistics">
								<div class="text-superlg text-primary">{{amountPaid(statistics && statistics.pending && statistics.pending.amount ? statistics.pending.amount : '0')}}</div>
								<div v-if="statistics && statistics.pending && statistics.pending.total !== 0" >{{$t('from ')}}<span class="text-primary">{{statistics && statistics.pending && statistics.pending.total ? statistics.pending.total : '0'}}</span> transactions</div>
								<div v-else>{{$t('There is no transaction')}}</div>
							</div>
						</div>
						<div class="card-statistics pointer" @click="openModalList('refund')">
							<div class="mt-3 p-5 text-center absolute" v-if="isFetchingStatistics">
								<div class="is-loading large"></div>
							</div>
							<h3 class="mb-2">{{$t('Refund')}}</h3>
							<div class="text-statistics" v-if="!isFetchingStatistics">
								<div class="text-superlg text-primary">{{amountPaid(statistics && statistics.refund && statistics.refund.amount ? statistics.refund.amount : '0')}}</div>
								<div v-if="statistics && statistics.refund && statistics.refund.total !== 0">{{$t('from ')}}<span class="text-primary">{{statistics && statistics.refund && statistics.refund.total ? statistics.refund.total : '0'}}</span> transactions</div>
								<div v-else>{{$t('There is no transaction')}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="!user.roles.includes('finance') && user.userSubscriptions.length === 0">
				{{$t('No invoice for next month')}}
			</div>
			<!-- Table Menu -->
			<div class="table-menu flex-center">
				<!-- filter paid-->
				<!-- <button class="btn btn-primary mr-3" :class="{'ml-a': isFinance}" v-if="isFinance" @click="openGenerateInvoice">
					Generate Invoice
				</button> -->
        <div :class="{'ml-a': isFinance}"></div>
				<div class="verified-icon-left text-center" :class="{'ml-a': !isFinance}"><i class="material-icons text-white absolute pt-1 text-lg pt-2">calendar_today</i></div>
				<div class="mr-3">
					<md-menu md-align-trigger :md-offset-x="-20">
						<button class="btn btn-filter-last-transaction p-0 m-0" md-menu-trigger>
								<span class="capitalize" v-if="orderBy === 'id'">{{$t('All')}}</span>
								<span class="capitalize" v-if="orderBy === 'created_at'">{{$t('Last Transaction')}}</span>
						</button>
						<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
						<md-menu-content>
							<md-menu-item @click="lastTransaction('all')"><span class="text-center minw-115">{{$t('All')}}</span></md-menu-item>
							<md-menu-item @click="lastTransaction('created_at')"><span class="text-center minw-115">{{$t('Last Transaction')}}</span></md-menu-item>
						</md-menu-content>
					</md-menu>
				</div>
				<!-- sort by-->
				<div class="verified-icon-left text-center"><i class="material-icons text-white absolute pt-1 text-lg pt-2">filter_list</i></div>
				<div class="mr-3">
					<md-menu md-align-trigger :md-offset-x="-20">
						<button class="btn btn-filter-last-transaction p-0 m-0" md-menu-trigger>
								<span class="tf-none" v-if="sortBy === 'desc'">{{$t('Newest on top')}}</span>
								<span class="tf-none" v-if="sortBy === 'asc'">{{$t('Newest on last')}}</span>
						</button>
						<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
						<md-menu-content>
							<md-menu-item @click="sortFilter('desc')"><span class="text-center minw-115">{{$t('Newest on top')}}</span></md-menu-item>
							<md-menu-item @click="sortFilter('asc')"><span class="text-center minw-115">{{$t('Newest on last')}}</span></md-menu-item>
						</md-menu-content>
					</md-menu>
				</div>
				<!-- counting -->
				<md-menu md-align-trigger md :md-offset-x=10 class="mr-3">
					<button class="btn-icon btn p-0 m-0 w-100 btn-click" md-menu-trigger>
							{{ page * limit - (limit - 1) }} - {{ items.length > 0 ? page * limit : items.length }} of {{ totalItems }}
					</button>
					<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
					<md-menu-content>
						<md-menu-item @click="changeLimit(10)"><span class="text-center minw-50">10</span></md-menu-item>
						<md-menu-item @click="changeLimit(25)"><span class="text-center minw-50">25</span></md-menu-item>
						<md-menu-item @click="changeLimit(50)"><span class="text-center minw-50">50</span></md-menu-item>
						<md-menu-item @click="changeLimit(100)"><span class="text-center minw-50">100</span></md-menu-item>
						<md-menu-item @click="changeLimit(200)"><span class="text-center minw-50">200</span></md-menu-item>
					</md-menu-content>
				</md-menu>
				<div>
					<input
						type="text"
						class="form-control"
						:placeholder="$t('Search')"
						@input="onKeywordChange"
						v-model="keyword"
					/>
				</div>
			</div>
			<!-- Main Table -->
			<table class="table table-striped mb-4">
				<thead>
					<tr>
						<th >{{ $t('No') }}</th>
						<th width="10%">{{ $t('Price') }}</th>
						<th width="20%">{{ $t('Package Name') }}</th>
						<th width="10%">{{ $t('Invoice') }}</th>
						<th width="20%">{{ $t('Buyer') }}</th>
						<th width="20%">{{ $t('Created') }}</th>
						<th width="20%"></th>
					</tr>
				</thead>
				<div class="p-5 text-center absolute" v-if="isFetching">
					<div class="is-loading large"></div>
				</div>
				<tbody>
					<tr
						v-for="(item, index) in items"
						:key="item.id" @dblclick="viewInvoice(item)">
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ numberingList(index) }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ amountPaid(item.amount) }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ item && item.package_name ? item.package_name : '-' }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ item.invoice_number }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ item && item.name ? item.name : '-'}}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ item.created_at }}</td>
						<td class="btn-action-table text-right" @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">
							<!-- if not custom invoice -->
							<button v-if="hover && hoverItem === item.id && item.id && item.invoice_number && item.stripe_invoice_id"
								class="btn btn-default btn-icon mr-3"
								v-tooltip="$t('Invoice Transaction')"
								@click="viewInvoice(item)">
								<i class="material-icons md-18">view_stream</i>
							</button>
							<button v-if="hover && hoverItem === item.id && item.id && item.invoice_number && user.roles.includes('finance') && item.stripe_invoice_id"
								class="btn btn-default btn-icon mr-3"
								v-tooltip="$t('Upcoming Invoice')"
								@click="viewNextInvoice(item)">
								<i class="material-icons md-18 icon-2-feedback">launch</i>
							</button>
							<button v-if="hover && hoverItem === item.id && item.id && item.invoice_number && (user.id === item.user_id) && item.stripe_invoice_id"
								class="btn btn-default btn-icon mr-3"
								v-tooltip="$t('Change Payment Method')"
								@click="changePaymentModal">
								<i class="material-icons md-18">credit_card</i>
							</button>
							<!-- custom Invoice -->
							<button v-if="hover && hoverItem === item.id && item.id && !item.stripe_invoice_id"
								class="btn btn-default btn-icon mr-3"
								v-tooltip="$t('Invoice Transaction')"
								@click="viewCustomInvoice(item)">
								<i class="material-icons md-18">view_stream</i>
							</button>
						</td>
					</tr>
				</tbody>
			</table>
			<div class="text-center absolute disabled mt-4" v-if="items.length === 0 && !isFetching">{{$t('No Transactions available')}}</div>
			<!-- Table Pagination -->
			<pagination
				v-if="!isFetching"
				:total-pages="totalPages"
				:current-page="page"
				:last-page="lastPage"
				@select="onPageSelected">
			</pagination>
		</div>
		<!-- Invoice Modal -->
		<invoice-modal
			:data="selected"
			:isCustomInvoice="isCustomInvoice"
			@close="isModalnvoiceVisible = false"
			v-if="isModalnvoiceVisible"
		/>
		<!-- Next Invoice Modal -->
		<invoice-upcoming-modal
			:mineId="mineId"
			:data="selected"
			@close="isModaNextlnvoiceVisible = false"
			v-if="isModaNextlnvoiceVisible"
			:user="user"
		/>
		<!-- Modal Generate Invoice -->
		<modal-generate-invoice
			:isShowGenerateInvoice="isModalGeneratenvoiceVisible"
			@close="isModalGeneratenvoiceVisible = false"
			v-if="isModalGeneratenvoiceVisible"
			@add="insertItem"
		/>
		<!-- modal change payment method -->
		<modal size="medium" :hideFooter="true" class="swap-modal" @close="isChangePaymentModal = false" v-if="isChangePaymentModal">
			<template slot="header">
				<h5 class="mb-0">{{ $t('Change Credit Card') }}</h5>
			</template>
			<template slot="body">
				<div class="col-sm-12 payment-form">
					<div>
						<form @submit.prevent="">
							<div>
								<h2 class="font-weight-normal">{{ $t('Payment') }}</h2>
							</div>
							<span>Subscription & payment are handled by </span><span><a href="https://stripe.com" target="_blank">Stripe</a></span>
							<div  class="form-group mt-3">
								<div class="mh-50">
									<input v-model="paymentName" type class="form-control field" placeholder="Name" :class="{'error-input': paymentName === '', 'mb-4': paymentName.length >= 5 || paymentName.length === 0}">
									<span v-if="paymentName.length < 5 && paymentName.length !== 0" class="error-color-input">Please enter a name of at least 5 characters</span>
								</div>
								<input v-model="paymentEmail" type="email" name="email" class="form-control field  mb-3" placeholder="E-mail" :class="{'error-input': paymentEmail === ''}">
								<div id="card-element" class="stripe-field"></div>
								<!-- We'll put the error messages in this element -->
								<div id="card-errors" role="alert"></div>
							</div>
							<div class="d-flex justify-content-between">
								<div>
									<button :class="{ 'is-loading': isPaymentSuccess }"
									class="btn btn-primary mb-2 mr-2" :disabled="!isValidNameAndEmail && isValidCreditCard" @click="createPaymentMethod">Change Credit Card</button>
								</div>
								<div>
									<button class="btn btn-default mb-2" @click="isChangePaymentModal = false">Cancel</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</template>
			<template slot="footer">
			</template>
		</modal>
		<!-- modal list per category -->
		<modal
			size="large"
			@close="closeModalList"
			v-if="isModalList"
			:hide-footer="true">
			<template slot="header">
				<label v-if="status === 'paid'">{{ $t('Paid') }}</label>
				<label v-if="status === 'pending'">{{ $t('Unpaid') }}</label>
				<label v-if="status === 'refund'">{{ $t('Refund') }}</label>
			</template>
			<template slot="body">
				<div class="table-menu flex-center">
					<!-- is last Login -->
					<div class="d-flex ml-a">
						<div v-if="orderByModal === 'created_at'" class="verified-icon-left text-center"><i class="material-icons text-white absolute pt-1">sort</i></div>
						<div v-if="orderByModal === 'amount'" class="verified-icon-left text-center"><i class="material-icons text-white absolute pt-1">attach_money</i></div>
						<div v-if="orderByModal === 'package_name'" class="verified-icon-left text-center"><i class="material-icons text-white absolute pt-1">receipt</i></div>
						<div v-if="orderByModal === 'name'" class="verified-icon-left text-center"><i class="material-icons text-white absolute pt-1">person</i></div>
						<div class="mr-3">
							<md-menu md-align-trigger :md-offset-x="-30">
								<button class="btn btn-filter-last-login p-0 m-0" md-menu-trigger>
										<span class="capitalize" v-if="orderByModal === 'created_at'">{{$t('All')}}</span>
										<span class="capitalize" v-if="orderByModal === 'amount'">{{$t('Price')}}</span>
										<span class="capitalize" v-if="orderByModal === 'package_name'">{{$t('Package')}}</span>
										<span class="capitalize" v-if="orderByModal === 'name'">{{$t('Buyer')}}</span>

								</button>
								<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
								<md-menu-content>
									<md-menu-item @click="sortByFilter('created_at')"><span class="text-center minw-85">{{$t('All')}}</span></md-menu-item>
									<md-menu-item @click="sortByFilter('price')"><span class="text-center minw-85">{{$t('Price')}}</span></md-menu-item>
									<md-menu-item @click="sortByFilter('package')"><span class="text-center minw-85">{{$t('Package')}}</span></md-menu-item>
									<md-menu-item @click="sortByFilter('buyer')"><span class="text-center minw-85">{{$t('Buyer')}}</span></md-menu-item>

								</md-menu-content>
							</md-menu>
						</div>
					</div>
					<!-- sort -->
					<div class="verified-icon-left text-center"><i class="material-icons text-white absolute pt-1 text-lg pt-2">filter_list</i></div>
					<div class="mr-3">
						<md-menu md-align-trigger :md-offset-x="-20">
							<button class="btn btn-filter-last-transaction p-0 m-0" md-menu-trigger>
									<span class="tf-none" v-if="sortByModal === 'desc'">{{$t('Newest on top')}}</span>
									<span class="tf-none" v-if="sortByModal === 'asc'">{{$t('Newest on last')}}</span>
							</button>
							<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
							<md-menu-content>
								<md-menu-item @click="sortFilterModal('desc')"><span class="text-center minw-115">{{$t('Newest on top')}}</span></md-menu-item>
								<md-menu-item @click="sortFilterModal('asc')"><span class="text-center minw-115">{{$t('Newest on last')}}</span></md-menu-item>
							</md-menu-content>
						</md-menu>
					</div>
				</div>
				<div class="mh-420">
					<table class="table table-striped mb-4">
						<div class="p-5 text-center absolute" v-if="isFetchingModal">
							<div class="is-loading large"></div>
						</div>
						<thead>
							<tr>
								<th >{{ $t('No') }}</th>
								<th width="20%">{{ $t('Price') }}</th>
								<th width="20%">{{ $t('Package Name') }}</th>
								<th width="20%">{{ $t('Invoice') }}</th>
								<th width="20%">{{ $t('Buyer') }}</th>
								<th width="20%">{{ $t('Created') }}</th>
							</tr>
						</thead>
						<div class="p-5 text-center absolute" v-if="isFetching">
							<div class="is-loading large"></div>
						</div>
							<tbody>
								<tr
									v-for="(item, index) in itemsModal"
									:key="item.id">
									<td>{{ numberingListModal(index) }}</td>
									<td>{{ amountPaid(item.amount) }}</td>
									<td>{{ item.package_name }}</td>
									<td>{{ item.invoice_number }}</td>
									<td>{{ item.name }}</td>
									<td>{{ item.created_at }}</td>
								</tr>
							</tbody>
						</table>
						<div class="text-center absolute disabled mt-4" v-if="itemsModal.length === 0 && !isFetchingModal">{{$t('No Transactions available')}}</div>
						<!-- Table Pagination -->
						<pagination
							v-if="!isFetchingModal"
							:total-pages="totalPagesModal"
							:current-page="pageModal"
							:last-page="lastPageModal"
							@select="onPageSelectedModal">
						</pagination>
					</div>
			</template>
		</modal>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Pagination from '@/components/Pagination.vue';
import { getAxiosErrorMessage, delay } from '@/lib/helper';
import InvoiceModal from '@/components/InvoiceModal.vue';
import ModalGenerateInvoice from '@/components/ModalGenerateInvoice.vue';
import InvoiceUpcomingModal from '@/components/InvoiceUpcomingModal.vue';
import transactionsApi from '@/api/transactions';
import Modal from '@/components/Modal.vue';
import userApi from '@/api/user';


const publicKeyStripe = process.env.VUE_APP_PK_STRIPE ? process.env.VUE_APP_PK_STRIPE : 'pk_test_cEeFbGOnhljGBjRCCjp7h3dL00SPobqhFE';

export default {
	name: 'Billings',
	components: {
		Pagination,
		InvoiceModal,
		InvoiceUpcomingModal,
		Modal,
		ModalGenerateInvoice,
	},
	data() {
		return {
			page: 1,
			limit: 10,
			orderBy: 'created_at',
			sortBy: 'desc',
			keyword: '',
			isAll: false,
			items: [],
			selected: null,
			// totalPages: 2,
			totalItems: 0,
			lastPage: 1,
			isFetching: false,
			hover: false,
			hoverItem: null,
			isModalnvoiceVisible: false,
			isModaNextlnvoiceVisible: false,
			isModalGeneratenvoiceVisible: false,
			mineId: '',
			// stripe
			isChangePaymentModal: false,
			paymentName: '',
			paymentEmail: '',
			isPaymentSuccess: false,
			isValidCreditCard: true,
			stripeAPIToken: publicKeyStripe,
			card: null,
			isSavingPayment: false,
			// statistics
			statistics: [],
			isFetchingStatistics: false,
			// modal items
			isModalList: false,
			status: '',
			itemsModal: [],
			lastPageModal: 1,
			totalItemsModal: 0,
			pageModal: 1,
			limitModal: 10,
			isFetchingModal: false,
			sortByModal: 'desc',
			orderByModal: 'created_at',
			isCustomInvoice: false,
			customNameInvoice: '',
		};
	},
	methods: {
		itemLeave() {
			this.hover = false;
			this.hoverItem = null;
		},
		itemHover(item) {
			this.hover = true;
			this.hoverItem = item.id;
		},
		...mapActions({
		}),
		viewInvoice(item) {
			this.isCustomInvoice = false;
			this.selected = item;
			this.isModalnvoiceVisible = true;
		},
		viewCustomInvoice(item) {
			this.isCustomInvoice = true;
			this.selected = item;
			this.isModalnvoiceVisible = true;
		},
		openGenerateInvoice() {
			this.isModalGeneratenvoiceVisible = true;
		},
		viewNextInvoice(item) {
			this.selected = item;
			this.isModaNextlnvoiceVisible = true;
		},
		viewNextInvoiceSelf(item) {
			this.mineId = item;
			this.isModaNextlnvoiceVisible = true;
		},
		fetch(reset = false, page) {
			this.isFetching = true;
			if (reset) {
				this.page = 1;
				this.items = [];
			}
			if (page) this.page = page;
			const params = this.fetchParams;
			const callback = (response) => {
				const items = response.data;
				if (items.length < this.limit) this.isAll = true;
				this.items = items;
				this.totalItems = response.total;
				this.lastPage = response.lastPage;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Transactions',
					text: message,
				});
				this.isFetching = false;
			};
			transactionsApi.getList(params, callback, errorCallback);
		},
		fetchStatistics() {
			this.isFetchingStatistics = true;
			const callback = (response) => {
				const items = response.data;
				this.statistics = items;
				this.isFetchingStatistics = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Transactions',
					text: message,
				});
				this.isFetchingStatistics = false;
			};
			if (this.isFinance) transactionsApi.statistic(callback, errorCallback);
		},
		onKeywordChange() {
			delay(() => {
				this.fetch(true);
			}, 500);
		},
		onPageSelected(page) {
			this.fetch(true, page);
		},
		onPageSelectedModal(pageModal) {
			this.fetchModal(true, pageModal);
		},
		changeLimit(value) {
			this.limit = value;
			this.fetch(true);
		},
		changePaymentModal() {
			this.paymentName = this.user && this.user.name ? this.user.name : '';
			this.paymentEmail = this.user && this.user.email ? this.user.email : '';
			this.isChangePaymentModal = true;
			this.$nextTick(() => {
				this.configureStripe();
			});
		},
		configureStripe() {
			// eslint-disable-next-line no-undef
			this.stripe = Stripe(this.stripeAPIToken, { locale: 'en' });
			this.elements = this.stripe.elements();
			this.card = this.elements.create('card', {
				style: {
					base: {
						iconColor: '#6051ff',
						color: 'white',
						lineHeight: '48px',
						fontWeight: 400,
						fontFamily: '"Open Sans", "Helvetica Neue", "Helvetica", sans-serif',
						fontSize: '15px',
						'::placeholder': {
							color: '#CFD7DF',
						},
					},
				},
			});
			this.card.mount('#card-element');

			this.card.on('change', (event) => {
				const displayError = document.getElementById('card-errors');
				if (event.error) {
					displayError.textContent = event.error.message;
					this.isValidCreditCard = false;
				} else if (event.empty) {
					displayError.textContent = '';
					this.isValidCreditCard = false;
				} else {
					displayError.textContent = '';
					this.isValidCreditCard = true;
				}
			});
		},
		// eslint-disable-next-line no-unused-vars
		createPaymentMethod({ card, isPaymentRetry }) {
			// eslint-disable-next-line no-undef
			this.stripe
				.createPaymentMethod({
					type: 'card',
					card: this.card,
					billing_details: {
						name: this.paymentName,
						email: this.paymentEmail,
					},
				})
				.then((result) => {
					// const transactionId = result.transaction_id;
					if (result.error) {
						this.isPaymentSuccess = false;
						const error = result.error;
						const message = error.message;
						this.$notify({
							group: 'app',
							type: 'error',
							title: 'Failed, Payment Declined',
							text: message,
						});
					}
					return result;
				}).then((result) => {
					const paymentMethod = result && result.paymentMethod ? result.paymentMethod : '';
					if (paymentMethod) {
						this.changePaymentMethod(paymentMethod);
					}
				});
		},
		changePaymentMethod(paymentMethod) {
			const customerId = this.user && this.user.customer_id ? this.user.customer_id : '';
			const paymentId = paymentMethod && paymentMethod.id ? paymentMethod.id : '';
			const params = {
				customer_id: customerId,
				payment_method_id: paymentId,
			};
			this.isSavingPayment = true;
			const callback = (response) => {
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Transactions',
					text: message,
				});
			};
			this.paymentName = '';
			this.paymentEmail = '';
			this.isSavingPayment = false;
			this.isChangePaymentModal = false;
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Transactions',
					text: message,
				});
				this.isSavingPayment = false;
			};
			userApi.changePaymentMethod(params, callback, errorCallback);
		},
		amountPaid(item) {
			const itemString = item.toString();
			const index = itemString.indexOf('-');
			if (index !== -1) {
				const removeMin = itemString.substring(1);
				return `-$${removeMin}`;
			}
			const addDelimiter = (item).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			return `$${addDelimiter}`;
		},
		openModalList(type) {
			this.isModalList = true;
			this.status = type;
			this.orderByModal = 'created_at';
			this.fetchModal();
		},
		fetchModal(reset = false, pageModal) {
			this.isFetchingModal = true;
			if (reset) {
				this.pageModal = 1;
				this.itemsModal = [];
			}
			if (pageModal) this.pageModal = pageModal;
			const params = {
				page: this.pageModal,
				limit: this.limitModal,
				order_by: this.orderByModal,
				sort_by: this.sortByModal,
				status: this.status,
				// role: this.role,
			};
			const callback = (response) => {
				const items = response.data;
				if (items.length < this.limitModal) this.isAll = true;
				this.itemsModal = items;
				this.totalItemsModal = response.total;
				this.lastPageModal = response.lastPage;
				this.isFetchingModal = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Transactions',
					text: message,
				});
				this.isFetchingModal = false;
			};
			transactionsApi.getList(params, callback, errorCallback);
		},
		closeModalList() {
			this.isModalList = false;
			this.status = '';
			this.itemsModal = [];
			this.totalItemsModal = 0;
			this.lastPageModal = 1;
			this.pageModal = 1;
			this.orderBy = 'created_at';
		},
		lastTransaction(filter) {
			if (filter === 'all') {
				this.orderBy = 'id';
			} else {
				this.orderBy = 'created_at';
			}
		},
		sortFilter(filter) {
			if (filter === 'asc') {
				this.sortBy = 'asc';
			} else {
				this.sortBy = 'desc';
			}
		},
		sortByFilter(filter) {
			if (filter === 'created_at') {
				this.orderByModal = 'created_at';
			} else if (filter === 'price') {
				this.orderByModal = 'amount';
			} else if (filter === 'package') {
				this.orderByModal = 'package_name';
			} else if (filter === 'buyer') {
				this.orderByModal = 'name';
			}
		},
		sortFilterModal(filter) {
			if (filter === 'asc') {
				this.sortByModal = 'asc';
			} else {
				this.sortByModal = 'desc';
			}
		},
		numberingList(index) {
			if (this.page >= 1) {
				return index + 1 + (this.page * 10 - 10);
			}
			return index + 1;
		},
		numberingListModal(index) {
			if (this.pageModal >= 1) {
				return index + 1 + (this.pageModal * 10 - 10);
			}
			return index + 1;
		},
		insertItem(item) {
			const index = this.items.findIndex(({ id }) => id === item.id);
			if (index === -1) {
				this.items.push(item);
			}
		},
	},
	computed: {
		fetchParams() {
			const params = {
				page: this.page,
				limit: this.limit,
				order_by: this.orderBy,
				sort_by: this.sortBy,
				status: '',
				// role: this.role,
			};
			if (!this.user.roles.includes('finance')) params.user_id = this.user.id;
			const keyword = this.keyword.trim();
			if (keyword !== '') params.keyword = keyword;
			return params;
		},
		totalPages() {
			const total = Math.ceil(this.totalItems / this.limit);
			return total;
		},
		totalPagesModal() {
			const total = Math.ceil(this.totalItemsModal / this.limitModal);
			return total;
		},
		...mapGetters({
			user: 'user',
			isSuperAdmin: 'isSuperAdmin',
			isCollaborator: 'isCollaborator',
			isFinance: 'isFinance',
		}),
		isValidNameAndEmail() {
			return this.paymentEmail !== '' && this.paymentName !== '' && this.paymentName.length > 5;
		},
		isHaveTransactions() {
			return this.user && this.user.transactions && this.user.transactions.length > 0;
		},
	},
	watch: {
		orderBy() {
			this.fetch(true);
		},
		sortBy() {
			this.fetch(true);
		},
		orderByModal() {
			this.fetchModal(true);
		},
		sortByModal() {
			this.fetchModal(true);
		},
	},
	created() {
		this.fetch();
		this.fetchStatistics();
	},
};
</script>
